//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.DepthSkewBuilder.js";
import "../GeometricUtilities/GeometricUtilities.BridgeCurveConnectivity.js";
import "../no/SelectNXObject.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.TangentMagnitudeBuilder.js";
import "../no/SelectCurve.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"ConstraintFaces",0,"ScCollector",0],[1,"ConstraintRadius",0,"Expression",0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"DepthSkew",0,"GeometricUtilities.DepthSkewBuilder",0],[1,"EndConnectivity",0,"GeometricUtilities.BridgeCurveConnectivity",0],[1,"EndObject",0,"SelectNXObject",0],[0,"EndObjectType",1,0],[1,"EndSection",0,"Section",0],[0,"EndVector",1,"Direction",0],[0,"IsAssociative",1,0],[0,"RadiusConstraintMethod",1,0],[1,"Rho",0,"Expression",0],[0,"ShapeControlMethod",1,0],[1,"StartConnectivity",0,"GeometricUtilities.BridgeCurveConnectivity",0],[1,"StartObject",0,"SelectNXObject",0],[0,"StartObjectType",1,0],[1,"StartSection",0,"Section",0],[1,"TangentMagnitude",0,"GeometricUtilities.TangentMagnitudeBuilder",0],[1,"TemplateCurve",0,"SelectCurve",0],[0,"UseNearestPointOnSection",1,0]],[[[],"UpdateOnEndVectorReversal",{},0,0],[[],"Evaluate",{},0,0]],[]];
SPLM.Features.BridgeCurveBuilderEx = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BridgeCurveBuilderEx";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.BridgeCurveBuilderEx.StartObjectTypes = Object.freeze({
    "Section" : "Section", "Object" : "Object"});

SPLM.Features.BridgeCurveBuilderEx.EndObjectTypes = Object.freeze({
    "Section" : "Section", "Object" : "Object", "Datum" : "Datum", "Vector" : "Vector"});

SPLM.Features.BridgeCurveBuilderEx.RadiusConstraintMethods = Object.freeze({
    "None" : "None", "Minimum" : "Minimum", "Peak" : "Peak"});

SPLM.Features.BridgeCurveBuilderEx.ShapeControlMethods = Object.freeze({
    "TangentMagnitude" : "TangentMagnitude", "DepthSkew" : "DepthSkew", "Conic" : "Conic", "TemplateCurve" : "TemplateCurve"});

export default SPLM;